<template>
    <v-dialog
      v-model="notice"
      fullscreen 
      persistent :overlay="false"
      transition="dialog-transition"
    >
    <div class= "dialog_body mt-5">
      <v-card>
      <div class="notice">
        <v-card-title title  >
          <v-flex xs12 text-xs-center>
          <p class="font-weight-bold" style="font-size: 2em; text-decoration: underline;">❗️CHANGEMENTS TRES IMPORTANTS DANS LE SWAP HIROPAY (échange instantanné)❗️</p>
          </v-flex>
        </v-card-title>
       <v-card-text>
        <v-flex xs12 text-xs-center>
          <p class="font-weight-bold" style="font-size: 1.2em">
            HIROPAY donne desormais la possibilité d'acheter et de vendre vos monnaies preferées sans effectuer de depot préalable, <br> l'option de depot reste toujours valabe, mais si vous desirez faire l'échange instantanné (SWAP),<br> vous pouvez maintenant le faire directement sans faire de depot CFA ou de PM, notez qu'avec cette option<br>
          une fois que vous validez le paiement sur votre mobile, la monnaie achetée est automatiquement <br> envoyée sur votre portefeuille. <br>
          Pour échanger directement suivez comment proceder en cliquant sur le <Guide_dialog /> <br>
          
          NB: vous pouvez à tout moment revoir le guide d'utilisation sur la page <v-btn flat router :to= "'/exchange'" color="success">SWAP</v-btn> en cliquant <br> sur le bouton GUIDE D'UTILISATION <br><br>
          <span style="font-size:1.3em;">MERCI POUR VOTRE FIDELITE A LA PLATEFORME HIROPAY</span> <br>
          <v-btn router :to= "'/exchange'" color="success">ALLER SUR LA PAGE SWAP</v-btn><br>
          </p>
          <v-btn class="mt-5" color="primary" @click="notice = false">FERMER</v-btn>
        </v-flex>
       </v-card-text>
      </div>
     </v-card>
    </div>
    </v-dialog>
</template>

<script>
const Guide_dialog = () => import("./Guid_dialog.vue");
    export default {
      components: {
        Guide_dialog,
      },
        data() {
            return {
                notice:true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>